export type AttributionWindow = 'ITD' | 'YTD' | 'QTD';
export const ATTRIBUTION_WINDOWS: AttributionWindow[] = ['ITD', 'YTD', 'QTD'];
export const EXTERNAL_STRATEGY_ID = 'External';

export type BreakdownGrain = 'account' | 'strategy';

export interface AccountRef {
	brokerId: string;
	brokerAccountId: string;
}

export interface SleeveHolding {
	brokerId: string;
	brokerAccountId: string;
	symbol: string;
	qty: number;
}

// A SleeveHolding flattened out of StrategyAttributionRow.holdings, carrying the owning row's
// strategyId/isExternal alongside — what df-positions-table groups by (brokerId,
// brokerAccountId, symbol) to split a broker-reported position into per-strategy rows.
export type SleeveHoldingRow = SleeveHolding & { strategyId: string; isExternal: boolean };

// Every *Pct here is a FRACTION (0.077 = +7.70 pts; allocation 0.10 = 10%) — render ×100 (R7).
export interface StrategyPeriodFigures {
	returnPct: number;
	pnl: number;
	contributionPct: number;
	hasData: boolean;
}

export interface StrategyAttributionRow {
	strategyId: string;
	isExternal: boolean;
	displayName?: string | null;
	note: string;
	lifecycle: string;
	accounts: AccountRef[];
	createdOn?: string | null;
	retiredOn?: string | null;
	periods: Record<string, StrategyPeriodFigures>;
	holdings: SleeveHolding[];
}

export interface StrategySleeveDeployment {
	strategyId: string;
	allocationPct: number;
	allocatedUsd: number;
	deployedUsd: number;
}

export interface StrategyDeployment {
	fundEquity: number;
	sleeves: StrategySleeveDeployment[];
	externalResidualPct: number;
	externalResidualUsd: number;
	externalDeployedUsd: number;
}

export type AllocationEventKind = 'created' | 'changed' | 'retired';

export interface StrategyAllocationEvent {
	strategyId: string;
	date: string;
	kind: AllocationEventKind | string;
	fromPct: number;
	toPct: number;
}

export interface StrategySeries {
	strategyId: string;
	allocationShare: number[];
	cumulativeContribution: number[];
}

export interface StrategyAttributionSeries {
	window: AttributionWindow;
	dates: string[];
	fundGrowthOf1: number[];
	sleeves: StrategySeries[];
	external: StrategySeries;
}

export interface StrategyAttributionResult {
	fundId: string;
	asOfDate: string;
	inceptionDate?: string | null;
	shipDate?: string | null;
	isDtdEstimated: boolean;
	computedAt: string;
	rows: StrategyAttributionRow[];
	fund: Record<string, StrategyPeriodFigures>;
	deployment?: StrategyDeployment | null;
	events: StrategyAllocationEvent[];
	series?: StrategyAttributionSeries | null;
	warnings?: string[] | null;
}
